import React, { Component } from 'react';

class ContainerLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
          collLeft: [
            {
              id: 1,
              subtitle: "Criteria 1",
              title: "Quality use of Key Literary Elements",
              text: "The story effectively uses characterisation, symbolism, and repetition to make emotional growth and mindfulness tangible for children.",
            },
            {
              id: 2,
              subtitle: "Criteria 2",
              title:
                "Issue of the Creation and Knowledge/Use of Intertextuality",
              text: "It addresses social justice themes of emotional literacy and inclusion while connecting to real experiences, SEL theory, and cross-cultural understanding.",
            },
          ],
        };
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collLeft.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerLeft;
